import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})

export class ConfiguracionService {

  API_URI = environment.API_URL;
  constructor(private http: HttpClient) { }

  // getLogo() {
  //   return this.http.get(`${this.API_URI}/configuracion/logo`);
  // }

  getRedesSociales() {
    return this.http.get(`${this.API_URI}/configuracion/redes`);
  }

  getBanners(seccion) {
    return this.http.get(`${this.API_URI}/configuracion/banners/${seccion}`);
  }

}
